<template>
  <div id="otivo-wrapper" class="w-full">
    <LoadingPage v-if="loading" />
    <Maintenance v-else-if="forceMaintenanceMode" />
    <RouterView v-else />
    <BaseModal />
    <!-- Theme Toggle for Testing (to be removed later) -->
    <ThemeToggle v-if="!loading && !forceMaintenanceMode && enableThemeToggle && !isDemoMode" />
  </div>
</template>

<script setup lang="ts">
import initDone from '@/initDone.ts'
import BaseModal from '@/components/Modals/BaseModal.vue'
import LoadingPage from '@/views/LoadingPage.vue'
import ThemeToggle from '@/components/ThemeToggle.vue'
import { computed, inject, onBeforeUnmount, onUnmounted, watch } from 'vue'
import { Auth0Symbol, IAuth0Plugin } from '@/lib/AuthenticatorPlugin.ts'
import useInactivityTimer from '@/composables/inactivityTimeout.ts'
import { useSessionStore } from '@/store/pinia/SessionStore.ts'
import Maintenance from '@/views/Otivo/Maintenance.vue'
import { cleanupLDClient, FeatureList, useLDFlag } from '@/lib/ldClient.ts'

const loading = computed(() => !initDone.value)
const forceMaintenanceMode = useLDFlag(FeatureList.MAINTENANCE_MODE, false)
const auth0 = inject(Auth0Symbol) as IAuth0Plugin
const inactivityTimer = useInactivityTimer(useSessionStore())

//temp
const enableThemeToggle = useLDFlag(FeatureList.ENABLE_THEME_TOGGLE, false)
const isDemoMode = useLDFlag(FeatureList.ENABLE_DEMO_MODE, false)

const init = async () => {
  if (auth0.isAuthenticated.value) {
    inactivityTimer.start(60)
  }
  console.timeEnd('[TIMER] ready')
}

onUnmounted(() => {
  inactivityTimer.stop()
})

watch(
  () => initDone.value,
  () => {
    init()
  }
)

onBeforeUnmount(() => {
  cleanupLDClient()
  inactivityTimer.stop()
})
</script>

<style></style>
